import endpoint from '../util/endpoint';
import conectionDebug from './conectionDebug';
import Connection from './connection';

const bus = new Connection({
    name: 'session',
    url: ({ storeGuid, sessionGuid }) =>
        storeGuid && sessionGuid && endpoint('storeManager.signalRSessionMonitor', { storeGuid, sessionGuid }).url,
    dependencies: { storeGuid: 'url.params.storeGuid' },
});
bus.options.debug = conectionDebug;
export default bus;
